import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { EndpointType } from 'src/app/models/endpoint-type';

@Component({
  selector: 'app-environment-endpoints',
  templateUrl: './environment-endpoints.component.html',
  styleUrl: './environment-endpoints.component.scss',
  standalone: false
})
export class EnvironmentEndpointsComponent implements OnChanges {
  @Input() data: any;
  @Input() isEndpointAvailable = false;
  @Input() accessTypeEndpoints: any[] = [];
  @Input() exploreTypeEndpoints: any[] = [];
  @Input() configTypeEndpoints: any[] = [];
  @Input() otherTypeEndpoints: any[] = [];
  @Output() copyEvent = new EventEmitter<string>();

  copy = false;
  dataLoading = true;

  ngOnChanges(changes: SimpleChanges) {
    if(changes['data'] && this.data) {
      if(this.data?.endpoints) {
        this.configTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.CONFIGURATION);
        this.accessTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.UI);
        this.exploreTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.API);
        this.otherTypeEndpoints = this.data?.endpoints.filter(endpoint => endpoint?.useType === EndpointType.OTHER);
        if (this.configTypeEndpoints.length > 0
          || this.accessTypeEndpoints.length > 0
          || this.exploreTypeEndpoints.length > 0
          || this.otherTypeEndpoints.length > 0) {
          this.isEndpointAvailable = true;
        } else {
          this.isEndpointAvailable = false;
        }
      } else {
        this.isEndpointAvailable = false;
      }
      this.dataLoading = false;

    }
  }
  navigateToUrl(url: string): void {
    if (url) window.open(url, '_blank');
  }

  onCopy(url: string): void {
    navigator.clipboard.writeText(url || '');
    this.copy = true;
    this.copyEvent.emit(url);
    setTimeout(() => (this.copy = false), 1500);
  }
}
